<template>
<w-sliding-popup ref="slidingPopup" title="이벤트 상태 변경" width="950px">
  <div slot="content">
    <!-- 대상 이벤트 정보 -->
    <div class="title-h4 title-bar">대상 이벤트 정보</div>
    <el-row class="mr-b25" type="flex" :gutter="20">
      <el-col :span="12" class="list form-list">
        <el-form ref="form" label-position="left">
          <el-form-item label="등급" label-width="120px">{{eventFormData.eventlevelName}}</el-form-item>
          <el-form-item label="관리구분" label-width="120px">{{eventFormData.managetypeName}}</el-form-item>
          <el-form-item label="최초 발생시각" label-width="120px">{{getDateFormatter(eventFormData.checkDatetime)}}</el-form-item>
          <el-form-item label="장애메시지" label-width="120px">{{eventFormData.eventMessage}}</el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12" class="list form-list">
        <el-form ref="form" size="mini" label-position="left">
          <el-form-item label="대상" label-width="120px">{{eventFormData.objName}}</el-form-item>
          <el-form-item label="자원구분" label-width="120px">{{eventFormData.rsctypeName}}</el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 상태 변경 이력 -->
    <div class="title-h4 title-bar">상태 변경 이력</div>
    <el-table-wrapper v-loading="loading" :data="eventHistData" :columns="targetEventColumn" :column-default="columnDefault" header-align="center" :pagination="true" style="width:100%;" border highlight-current-row>
      <template slot-scope="scope" slot="eventlevel-slot">
        <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
      </template>
      <template slot-scope="scope" slot="event-message-slot">
        <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
          동적
        </div>
        {{scope.row.eventMessage}}
      </template>
    </el-table-wrapper>
  </div>
</w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { columnDefault } from '@/constants/table';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import TroubleShootingAPI from '@/api/event/trouble-shooting';
import WEventlevelCell from '@/components/table/EventlevelCell';

export default {
  name: 'WEventStatusHistPopup',
  components: {
    WEventlevelCell,
  },
  props: {
    eventData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      columnDefault,
      eventFormData: {},
      eventHistData: [],
      targetEventColumn: [
        {
          prop: 'eventlevelId',
          label: '등급',
          width: 80,
          scopedSlot: 'eventlevel-slot',
          className: 'eventlevel',
          columnKey: 'eventlevelId',
          searchable: true,
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 80,
        },
        {
          prop: 'objName',
          label: '대상',
          width: 170,
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원구분',
          width: 135,
          searchable: true,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          searchable: true,
          scopedSlot: 'event-message-slot',
          showOverflowTooltip: true,
        },
        {
          prop: 'checkDatetime',
          label: '상태변경시각',
          width: 135,
          searchType: 'date',
          searchable: true,
          formatter: this.getDateFormatter,
        },
      ],
    };
  },
  watch: {
    eventData: {
      immediate: false,
      handler(val) {
        if (!isEmpty(val)) {
          this.eventFormData = val;
          this.loadEventHist();
        }
      },
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
    },
    /**
     * 이벤트 상태 변경 이력을 조회한다.
     * @author Ju
     * @return
     */
    loadEventHist() {
      const params = {
        objId: this.eventData.objId,
        troubleTicketGroupId: this.eventData.troubleTicketGroupId,
        managetypeId: this.eventData.managetypeId,
        rsctypeId: this.eventData.rsctypeId,
        rscId: this.eventData.rscId,
        rscKey: this.eventData.rscKey,
      };
      this.loading = true;
      TroubleShootingAPI.getTroubleShootingTargeEventHistList(params)
        .then((response) => {
          if (response.data.success) {
            this.eventHistData = response.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '상태 변경 이력', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '상태 변경 이력', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      } else if (isNil(value) && isNil(column) && !isNil(row)) {
        return getDateToString(row);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/components/popup/EventStatusHistPopup.vue